import { useState } from "react";
import Navigator from "../../component/navigator";
import styles from "./index.module.scss";
import { Playground, PlaygroundRunParams } from "@quark/design";
import { execCode, ExecCodeResp } from "../../api";
import useDocumentTitle from "../../hooks/use-document-title";

const OnlinePlayground = () => {
  const [dataSource] = useState({
    stdin: "",
    source_code: 'print("hello world")',
    language: "python",
  });
  const [dataResult, setDataResult] = useState<ExecCodeResp | undefined>(
    undefined
  );
  const [running, setRunning] = useState(false);

  useDocumentTitle("在线编程");

  const runCode = (runParams: PlaygroundRunParams) => {
    if (!runParams.source_code || !runParams.source_code.trim()) {
      // todo 提示未输入
      return;
    }
    setRunning(true);
    execCode(runParams)
      .then((data) => {
        setDataResult(data);
      })
      .finally(() => {
        setRunning(false);
      });
  };

  return (
    <div className={styles.container}>
      <Navigator activeKey="online-editor" />
      <div className={styles.content}>
        <Playground
          running={running}
          dataSource={dataSource}
          dataResult={dataResult}
          onRun={runCode}
        />
      </div>
    </div>
  );
};

export default OnlinePlayground;
